import { useEffect, useState } from "react";
import { Grid, Radio, RadioGroup, FormControlLabel, FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";

//import styles
import "./style-question.scss";

function StyleQuestion({ activeIndex, styleQuestion, handleQuestionActivation, generateAnswers, userAnswers }) {
    //general variables
    const { t } = useTranslation();

    //handling onchange answer & send answer to parent component
    const [optionList, setOptionList] = useState(null);

    //update options based on user answers
    useEffect(() => {
        const updateOptionsWithUserAnswers = () => {
            return styleQuestion.possibleAnswers.map((option, index) => {
                const userAnswerValue = userAnswers[option.groupName];
                if (userAnswerValue !== undefined && userAnswerValue !== null) {
                    option.checked = userAnswerValue === option.value;
                    if (userAnswerValue === option.value) {
                        generateAnswers({ name: option.groupName, value: option.value });
                    }
                    if (index === styleQuestion.possibleAnswers.length - 1) {
                        handleQuestionActivation(4);
                    }
                }
                return option;
            });
        };

        if (userAnswers) {
            setOptionList(updateOptionsWithUserAnswers());
        } else {
            setOptionList(styleQuestion.possibleAnswers);
        }
    }, [userAnswers]);

    const handleChange = e => {
        const name = e.target.name;
        const value = parseInt(e.target.value);

        generateAnswers({ name, value });
        handleQuestionActivation(activeIndex + 1);

        setOptionList(prevOptions =>
            prevOptions.map(option => (option.groupName === name ? { ...option, checked: option.value === value } : option)),
        );
    };

    return (
        <Grid className={`style-question`} style={{ backgroundImage: `url(${styleQuestion.background})` }} container item md={5.8}>
            <Grid className="style-question__title" container item xs={12} justifyContent="center" alignItems="flex-start">
                {t(styleQuestion.label)}
            </Grid>

            <Grid className="style-question__question-options" container item xs={12} justifyContent="center" alignItems="center">
                <FormControl component="fieldset">
                    <RadioGroup>
                        {optionList?.map(option => (
                            <div key={option.label + option.groupName}>
                                <FormControlLabel
                                    control={
                                        <Radio
                                            disabled={!styleQuestion.active || option.disabled}
                                            value={option.value}
                                            checked={option.checked}
                                            name={option.groupName}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={t(option.label)}
                                    className={`style-question__option ${option.disabled ? "disabled" : ""}`}
                                />
                            </div>
                        ))}
                    </RadioGroup>
                </FormControl>
            </Grid>
        </Grid>
    );
}

export default StyleQuestion;
